import Vue from 'vue'
import axios from 'axios'
function successFn (res) {
  let d = res.data || {}
  if (d.ret === 1) {
    return d.data
  } else {
    Vue.prototype.$notify.error({
      title: '接口错误',
      message: (d.error && d.error.msg) || '未知原因，请联系开发人员'
    })
  }
}
function errorFn (error) {
  Vue.prototype.$notify.error({
    title: '内部错误',
    message: error || '未知原因，请联系开发人员'
  })
}
const BASE_OPT = {
  timeout: 8000 // 请求超时时间 8秒
}
// axios.defaults.withCredentials = true

const create = (opt) => {
  const service = axios.create({
    ...BASE_OPT,
    ...opt
  })
  // 请求劫持 头部绑定携带 aph_key
  if (process.env.NODE_ENV === 'development') {
    service.interceptors.request.use(req => {
      req.headers['aph_key'] = process.env.aph_key
      return req
    })
  }
  // 接口返回错误格式则拦截 错误格式：无ret & 无error字段 PS:
  service.interceptors.response.use(successFn, errorFn)
  // console.log(service, 'service')
  return service
}

export default {
  create
}



// WEBPACK FOOTER //
// ./src/api/interceptors.js